import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, FileDown } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { COMPANY } from "@/i18n";

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;

  return (
    <footer data-testid="site-footer" className="relative bg-black pt-24 pb-10 overflow-hidden">
      <div className="spot-glow w-[500px] h-[300px] bg-[#D4AF37]/8 -top-10 left-1/3" />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 relative">
        <div className="grid md:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={COMPANY.logo} alt="Kruška" className="h-14 w-14 rounded-full ring-1 ring-white/10" />
              <div>
                <p className="font-display font-extrabold text-lg tracking-tight text-white leading-none">
                  KRUŠKA DISTRIBUCIJA
                </p>
                <p className="text-xs text-[#D4AF37] tracking-widest mt-1">KRUŠEVAC</p>
              </div>
            </div>
            <p className="mt-6 text-zinc-400 max-w-sm">{f.tagline}</p>
            <a
              href={COMPANY.catalogPdf}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-catalog-download"
              className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-full border border-white/20 text-white text-sm font-semibold hover:border-[#D4AF37]/60 hover:bg-white/5 transition-all"
            >
              <FileDown size={16} /> Katalog 2026 (PDF)
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-5">{f.quick}</p>
            <ul className="space-y-3 text-zinc-300">
              <li><a href="#categories" className="hover:text-[#D4AF37] transition-colors">{t.nav.categories}</a></li>
              <li><a href="#supply" className="hover:text-[#D4AF37] transition-colors">{t.nav.supply}</a></li>
              <li><a href="#offers" className="hover:text-[#D4AF37] transition-colors">{t.nav.offers}</a></li>
              <li><Link to="/catalog" className="hover:text-[#D4AF37] transition-colors">{t.nav.catalog}</Link></li>
              <li><a href="#inquiry" className="hover:text-[#D4AF37] transition-colors">{t.nav.inquiry}</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-5">{t.nav.contact}</p>
            <ul className="space-y-3 text-zinc-300">
              <li className="flex items-center gap-3"><Phone size={16} className="text-[#D4AF37]" /><a href={`tel:${COMPANY.phoneHref}`} className="hover:text-white">{COMPANY.phone}</a></li>
              <li className="flex items-center gap-3"><Phone size={16} className="text-[#D4AF37]" /><a href={`tel:${COMPANY.phone2Href}`} className="hover:text-white">{COMPANY.phone2}</a></li>
              <li className="flex items-center gap-3"><Mail size={16} className="text-[#D4AF37]" /><a href={`mailto:${COMPANY.email}`} className="hover:text-white break-all">{COMPANY.email}</a></li>
              <li className="flex items-start gap-3"><MapPin size={16} className="text-[#D4AF37] mt-1" /><span>{COMPANY.address}</span></li>
            </ul>
            <div className="mt-6 text-xs text-zinc-500 space-y-1">
              <p>{f.legal}: PIB {COMPANY.pib} · MB {COMPANY.mb}</p>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">
            © {new Date().getFullYear()} {COMPANY.name}. {f.rights}
          </p>
          <p className="text-xs text-[#D4AF37]/70 font-mono">{f.b2b}</p>
        </div>
      </div>
    </footer>
  );
};
